import { pxToPercents, valueFromString } from "./functions";
export const onDragStop = ({ d, updateLayoutItem, layoutItem, screenHeight, screenWidth, }) => {
    const { x, y } = d;
    if (valueFromString(layoutItem.x, screenWidth) === x &&
        valueFromString(layoutItem.y, screenHeight) === y)
        return;
    if (layoutItem.unit === "%") {
        updateLayoutItem(Object.assign(Object.assign({}, layoutItem), { x: pxToPercents(x.toString(), screenWidth), y: pxToPercents(y.toString(), screenHeight) }));
    }
    if (layoutItem.unit === "px") {
        updateLayoutItem(Object.assign(Object.assign({}, layoutItem), { x: `${Math.round(x)}px`, y: `${Math.round(y)}px` }));
    }
};
export const onResizeStop = ({ ref, position, layoutItem, updateLayoutItem, screenWidth, screenHeight, direction, }) => {
    if (layoutItem.unit === "%") {
        updateLayoutItem(Object.assign(Object.assign({}, layoutItem), { width: pxToPercents(ref.offsetWidth.toString(), screenWidth), height: layoutItem.height !== "auto"
                ? pxToPercents(ref.offsetHeight.toString(), screenHeight)
                : "auto", x: pxToPercents(position.x.toString(), screenWidth), y: pxToPercents(position.y.toString(), screenHeight) }));
    }
    if (layoutItem.unit === "px") {
        updateLayoutItem(Object.assign(Object.assign({}, layoutItem), { width: `${Math.round(ref.offsetWidth)}px`, height: layoutItem.height !== "auto"
                ? `${Math.round(ref.offsetHeight)}px`
                : "auto", x: `${Math.round(position.x)}px`, y: `${Math.round(position.y)}px` }));
    }
};
